const storage: Storage = window.localStorage;

export default storage;
